import React, { Suspense, useEffect } from 'react';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

function FallBack() {
  useEffect(() => {
    NProgress.start();
    return () => {
      NProgress.done();
    };
  }, []);

  return '';
}

function RouteSuspense({ children }) {
  return <Suspense fallback={<FallBack />}>{children}</Suspense>;
}

export default RouteSuspense;
